import src from "IMAGE";
export default { src, width: 108, height: 256, blurWidth: 0, blurHeight: 0};
